import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CONFIG } from '../../constants/constants';
import { ConfiguracionDTO } from '../../model/configuracion.dto';
import { Combo } from '../../model/combo';
import { CodResp } from '../../constants/codigosMensajes';
import { Examen } from '../../model/examen';
import { GlobalParametersPlexiDTO } from '../../model/GlobalParametersPlexiDTO';
import { catchError, timeout } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ConfigurationControlService } from './configurationControl.service';

// Clase para control del objeto de respuestas entre componentes
@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {


  // Constructor de la clase
  constructor(private http: HttpClient,
    private _configurationControlService: ConfigurationControlService,
  ) {
    this.http = http;
  }


  /*Se encarga de consultar la informacion de configuracion
  del examen dependiendo del nombre de usuario*/
  public loadExamConfiguration(idCombo: any,
    token: string,
    user: string): Promise<ConfiguracionDTO> {

    let resp: any;
    let _headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': token,
      'idCombo': idCombo,
      'user': user
    });
    return this.http.post<ConfiguracionDTO>(CONFIG.REST_END_POINT + 'loadExamConfiguration/', null,
      { headers: _headers })
      .toPromise();

  }

  /*Se encarga de obtener la bandera que indica si el demo está activo*/
  public getGlobalConfiguration(): Promise<GlobalParametersPlexiDTO> {
    let _headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.get<GlobalParametersPlexiDTO>(CONFIG.REST_END_POINT + 'getGlobalParametersPlexi/', { headers: _headers })
      .toPromise();
  }


  /*Se encarga de obtener un listado con los combos activos para demo*/
  public getCombosDemo(): Promise<Combo[]> {
    let _headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.get<Combo[]>(CONFIG.REST_END_POINT + 'getCombosDemo/', { headers: _headers })
      .toPromise();
  }

  // Encargado de consultar un usuario demo y que sea asociado al combo seleccionado por el usuario
  public getDemoUser(idCombo: string, documento: string): Promise<string> {
    let self = this;

    if (idCombo) {
      let _headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'idCombo': idCombo,
        'documento': documento
      });
      const options: {
        headers?: HttpHeaders,
        observe?: 'body',
        params?: HttpParams,
        reportProgress?: boolean,
        responseType: 'text',
        withCredentials?: boolean
      } = {
        headers: _headers,
        responseType: 'text'
      };

      return this.http.post(CONFIG.REST_END_POINT + 'getUserDemo/', null, options).toPromise();

    } else {
      console.log('error from service');
    }
  }

  /*Se encarga de obtener la bandera que indica si se va a solicitar documento en demo*/
  public getDocumentDemoFlag(): Promise<Boolean> {
    let _headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.get<Boolean>(CONFIG.REST_END_POINT + 'getDocumentFlag/', { headers: _headers })
      .toPromise();
  }

  /* Método para identificar el mensaje de error a partir del código*/
  public getMessageByCode(idEstado: String): string {
    let message = '';
    var keepGoing = true;
    for (let i = 0; i < CodResp.length; i++) {
      if (keepGoing) {
        if (idEstado != null && idEstado != '') {
          let cod = CodResp[i].codigo;
          if (cod == idEstado) {
            message = CodResp[i].nombre;
            keepGoing = false;
          }
        }
      }
    }
    return message;
  }

  /*Se encarga de obtener un listado con los combos activos para demo*/
  public getExamenes(): Promise<Examen[]> {
    let _headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.get<Examen[]>(CONFIG.REST_END_POINT + 'getExamenes/', { headers: _headers })
      .toPromise();
  }

  /**
   *Se encarga de inhabilitar el botón atrás de cualquier navegador
   */
  public inhabilitarBotonAtras() {
    // window.location.hash = "no-back-button";
    // window.location.hash = "Again-No-back-button"
    // window.onhashchange = function () { window.location.hash = "no-back-button"; }
    if (window.location.pathname !== '/login') {
      window.location.hash = "no-back-button";
      window.onhashchange = function () { window.location.hash = "no-back-button"; }
    }
  }

  /** Encargado de verificar si tenemos conexion a internet */
  public callRequestDeprecate(): Promise<any> {
    const options: {
      headers?: HttpHeaders,
      observe?: 'body',
      params?: HttpParams,
      reportProgress?: boolean,
      responseType: 'text',
      withCredentials?: boolean,
      timeout: number,
    } = {
      headers: null,
      responseType: 'text',
      timeout: this._configurationControlService.timeoutService
    };
    return this.http.get(CONFIG.REST_END_POINT + 'test/', options).toPromise();
  }

  public callRequest(): Promise<any> {
    const url = CONFIG.REST_END_POINT + 'test/';
    const timeoutDuration = this._configurationControlService.timeoutService; // Establecer el tiempo de espera en milisegundos
    return this.http.get(url).pipe(
      timeout(timeoutDuration),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          // Manejar el error de tiempo de espera
          console.log('La solicitud excedió el tiempo de espera.');
        }
        return throwError(error);
      })
    ).toPromise();
  }
}

